import React, { createRef } from "react";

import {
    Input,
    Row, Col,
    Card,
    CardBody,
    FormGroup,
    Button,

} from "reactstrap";
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import { useSortBy, useTable } from "react-table";
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import _, { times } from 'underscore';
import PropTypes from 'prop-types';
import {BasicTableDetails} from './TableDetails'
import InputSelect from "../FormParts/InputSelect";

const propTypes = {
    pageChangeFunc: PropTypes.func,
    limitChangeFunc: PropTypes.func,
}
export default class OriginalTableDetails extends React.Component {
    constructor(props) {
        super(props);
        
        this.allCheckRef = createRef();
        this.state = this.addAllCheckField({
            default_column: this.props.column ? this.props.column : [],
            column: this.props.column ? this.props.column : [],
            sort_column: this.props.sort_column? this.props.sort_column : [],
            data: this.props.data ? this.props.data : [],
            column_select_area_visible: false,
            column_sort_area_visible: false,
            tmp_column: [],
            tmp_sort: {
                col: "",
                ask: true
            },
            detail_search: false,
            with_all_check: this.props.with_all_check ? this.props.with_all_check : false,
            all_check: this.props.all_check? this.props.all_check:false,
            change_all_check_flg: this.props.change_all_check_flg? this.props.change_all_check_flg:false,
            mode: this.props.mode ? this.props.mode : 0, // 0: その他大勢 1: 調査詳細モード
            perPage: this.props.perPage? this.props.perPage:50,
            sortOptions:this.props.defaultSortedColumn?this.props.defaultSortedColumn:[],
            count: this.props.count? this.props.count:0,
            perPage_options:this.props.perPage_options?this.props.perPage_options:[5,10,20,25,50,100],
            pageIndex: this.props.pageIndex? this.props.pageIndex: 0,
            checkedItems: this.props.checkedItems? this.props.checkedItems: [],
            unique_key: this.props.unique_key? this.props.unique_key: "",
            reloaded:false,
			resetExpanded: props.resetExpanded? props.resetExpanded: false,
			expanded: {},

            // 2022/10/25
            defaultShowRecodeFlag: this.props.defaultShowRecodeFlag? this.props.defaultShowRecodeFlag: true,
            defaultShowSortedFlag: this.props.defaultShowSortedFlag? this.props.defaultShowSortedFlag: false 
        });
        //console.log(this.state);
        // this.addAllCheckField = this.addAllCheckField.bind(this);
        this.handleColumnChange = this.handleColumnChange.bind(this);
        this.setReactTableColumn = this.setReactTableColumn.bind(this);
        this.allCheckChanged = this.allCheckChanged.bind(this);
        this.updateChecked = this.updateChecked.bind(this);
        this.targettedDefaultColumn = this.targettedDefaultColumn.bind(this);
        this.detail_search_field_view = this.detail_search_field_view.bind(this);

        /* 2021/06/08 scroll to list top */
        this.currentRef = createRef();
        this.pageChange = this.pageChange.bind(this);

        /* 2021/06/18 out of 1000 limit */        
        this.pagingHeader = this.pagingHeader.bind(this);
        this.nextView = this.nextView.bind(this);
        this.beforeView = this.beforeView.bind(this);
        this.changePerPage = this.changePerPage.bind(this);
        this.validPageNum = this.validPageNum.bind(this);
        this.addViewColumn = this.addViewColumn.bind(this);
		this.clickRowCallback = this.clickRowCallback.bind(this);
        this.handleChangeSortCols = this.handleChangeSortCols.bind(this);
        this.handleChangeSortBy = this.handleChangeSortBy.bind(this);
        this.setSortBySearchData = this.setSortBySearchData.bind(this);
        /*
        this.select_show_recode_btn = this.select_show_recode_btn.bind(this);
        this.sorted_options_btn = this.select_show_recode_btn.bind(this);
        this.select_show_recode_view = this.select_show_recode_view.bind(this);
        this.sorted_options_view = this.sorted_options_view.bind(this);
*/
        this.pageHeaderRef = createRef();
        this.pageFooterRef = createRef();
        this.pageLimitHeaderRef = createRef();
        this.pageLimitFooterRef = createRef();
    }

    // #1198
    addViewColumn () {
        let localStrageColumns;

        if (localStrageColumns = GsuiteAuth.get("all_column__" + this.props.page_id)) {
            const parseColumns = JSON.parse(localStrageColumns);
//            console.log(parseColumns);
            let ret = this.state.default_column.filter((col)=>{
                let matches = parseColumns.filter(parse_col=>parse_col.accessor == col.accessor);
//                console.log(matches);
                if ( matches.length == 0 ) {
//                    console.log(col);
                    return col;
                }
            });
//            console.log(ret);
            if (ret.length > 0) {
//                console.log(this.state.default_column)
                GsuiteAuth.set("all_column__" + this.props.page_id,JSON.stringify(this.state.default_column));
            }
            return ret;
        }
        else {
            GsuiteAuth.set("all_column__" + this.props.page_id,JSON.stringify(this.state.default_column));
            return this.state.default_column.filter((col)=>col.add_flg == true);
        }
    }

    UNSAFE_componentWillMount() {
        const column = this.state.default_column.map((data) => {
            if(data.defaultView === true){
                return data;
            }else if(data.defaultView === undefined){
                data.show = true;
                return data;
            }else{
                data.show = false;
                return data;
            }
        });
        
        if ( this.props.count != this.state.count ) {
            this.setState({count:this.props.count});
        }

        let addColumns = this.addViewColumn();
//        console.log(addColumns);


        const stringSavedColumn = GsuiteAuth.get(this.props.page_id)
        const jsonSavedColumn = (addColumns.length>0)? JSON.parse(stringSavedColumn).concat(addColumns) : JSON.parse(stringSavedColumn)
        const filteredColumn = jsonSavedColumn && jsonSavedColumn.filter((column)=>column.accessor != 'check')

//        console.log(jsonSavedColumn);
        this.setState({
            column: column,
            tmp_column:(this.props.page_id&&stringSavedColumn)
                ?(this.state.with_all_check
                    ?[
                        ...filteredColumn
                    ]
                    :jsonSavedColumn)
                :column
        }, ()=>{
            this.setReactTableColumn();
            // console.log(this.state.column);
        })
    }
    
    addAllCheckField(state) {
//        console.log("addAllCheckField",state.all_check);
//        console.log("addAllCheckField",this.props.all_check);

        const checkColumn = { Header: <input type="checkbox" name="all_check" ref={this.allCheckRef} defaultChecked={this.props.all_check} onChange={(e) => { this.allCheckChanged(e) }} />, headerLabel: '□', accessor: 'check', sortable: false, width:50,minWidth:50,headerClassName: "text-center", className: "text-center", nonTargetFilter: true, allCheckField: true, isSortDisabled:true };

        return {
            ...state,
            ...{column: (state.with_all_check && !state.column.find(col=>col.accessor=="check")? [checkColumn,...state.column] : state.column)},
            ...{default_column: (state.with_all_check? [...state.default_column] : state.default_column)}
        }
    }

    allCheckChanged(e) {
//        console.log("allCheckChanged",e.target.checked);
        let data = _.map(this.state.data, (item) => {
            item.checked = e.target.checked;
            return item;
        });

//        this.allCheckChanged.target.checked=e.target.checked;
//        this.setState({ all_check: true, data: data }, () => { this.props.checkedChangeCallback && this.props.checkedChangeCallback(data) });
        this.setState({ all_check: e.target.checked, data: data}, () => { this.props.checkedChangeCallback && this.props.checkedChangeCallback(data, this.state.all_check) });
    }

    componentDidMount(){
        // let ps;
        // let tables = document.querySelectorAll(".rt-table");
        // for (let i = 0; i < tables.length; i++) {0
        //     ps = new PerfectScrollbar(tables[i]);
        // }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ( this.props.count != this.state.count && !isNaN(this.props.count)) {
            this.setState({count: this.props.count });
        }
        if ( this.props.sort_column != this.state.sort_column && !isNaN(this.props.sort_column)) {
            this.setState({sort_column: this.props.sort_column });
        }

        if ( this.props.pageIndex != this.state.pageIndex && !isNaN(this.props.pageIndex )) {
            this.setState({pageIndex: this.props.pageIndex });
        }
        if (this.props.defaultShowRecodeFlag != this.state.defaultShowRecodeFlag && !isNaN(this.props.defaultShowRecodeFlag))
        {
            this.setState({defaultShowRecodeFlag: this.props.defaultShowRecodeFlag });
        }
        if (this.props.defaultShowSortedFlag != this.state.defaultShowSortedFlag && !isNaN(this.props.defaultShowSortedFlag))
        {
            this.setState({defaultShowSortedFlag: this.props.defaultShowSortedFlag });
        }
        
//        console.log("prevProps",prevProps.all_check,"prevState",prevState.all_check);
//        console.log("props checked",this.props.all_check,"state checked",this.state.all_check);

        if ( this.pageHeaderRef.current ) {
            this.pageHeaderRef.current.value = this.state.pageIndex + 1;
            this.pageLimitHeaderRef.current.value = this.state.perPage;
        }
        if ( this.pageFooterRef.current ) {
            this.pageFooterRef.current.value = this.state.pageIndex + 1;
            this.pageLimitFooterRef.current.value = this.state.perPage;
        }

        if (JSON.stringify(this.props.data) === JSON.stringify(prevProps.data))
            return;

        this.setState(this.addAllCheckField({
            ...this.state,
            data:this.props.data
        }));

        if (this.allCheckRef.current) {
            if ( this.props.all_check != this.allCheckRef.current.checked ) {
                this.allCheckRef.current.checked = this.props.all_check;
            }
        }

        if ( this.props.resetExpanded === true ) {
            this.setState({
				expanded: {}
			})
        }

		if ( this.props.resetExpanded != this.state.resetExpanded ) {
            this.setState({
				resetExpanded: this.props.resetExpanded,
				expanded: this.props.resetExpanded == true? {}: this.state.expanded
			})
		}
    }

    

    targettedDefaultColumn() {
        return this.state.default_column.filter((item) => { return !item.nonTargetFilter; });
    }

    //テーブル定義用
    handleColumnChange(e) {
        var column = [];

        _.each(this.state.default_column, (item) => {
            if(item.nonTargetFilter) {
                column.push(item);
            }
        });
        let targetted_default_column = this.targettedDefaultColumn();
        _.each(e.target, (item) => {
            if (!item.nonTargetFilter && item.selected) {
                column.push(targetted_default_column[item.value]);
            }
        });
        this.setState({ tmp_column: column });

    }

    getComparableValue(props){
        const tagRegex = /(<([^>]+)>)/ig
        if (props.dangerouslySetInnerHTML){
            return props.dangerouslySetInnerHTML.__html.replace(tagRegex,'')
        } else if (props.children) {
            return props.children.props ? props.children.props.defaultValue: props.children
        } else {
            return props.value
        }
    }

    setReactTableColumn(e) {
        const sortMethod = (a, b) => {
            const valueA = (a && (a.props?this.getComparableValue(a.props):a)) || ""
            const valueB = (b && (b.props?this.getComparableValue(b.props):b)) || ""
            return valueA >= valueB ? 1 : -1;
        }
        const t_column = this.state.tmp_column.map((item) => {
            item.show=true
            const columnData = this.state.default_column.find(element=>element.accessor == item.accessor)
            return {
                ...item,
                ...columnData,
                ...columnData&&(columnData.sortMethod?{}:{sortMethod})
            }
        });
        const checkColumn = { Header: <input type="checkbox" name="all_check" ref={this.allCheckRef} defaultChecked={this.state.all_check} onChange={(e) => { this.allCheckChanged(e) }} />, headerLabel: '□', accessor: 'check', sortable: false, width:50,minWidth:50,headerClassName: "text-center", className: "text-center", nonTargetFilter: true, allCheckField: true, isSortDisabled:true };
        this.setState({ column: (this.state.with_all_check && !t_column.find(col=>col.accessor=="check")? [checkColumn,...t_column] : t_column)}, ()=>{
//            console.log(this.state.column)
        });
        GsuiteAuth.set(this.props.page_id, JSON.stringify(this.state.tmp_column))
    }

    updateChecked(e, idx) {
        let data = _.map(this.state.data, (element, index, array) => {
            if (idx === index) {
                element.checked = e.target.checked;
            }
            return element;
        });
        this.setState({ data: data }, this.props.checkedChangeCallback && this.props.checkedChangeCallback(data, e.target.checked));
    }

    select_show_recode_btn () {
        if ( this.state.defaultShowRecodeFlag === true ) {
            return(<>
                <Col md="2">
                    <ButtonWithTooltip
                        onclick={() => { this.setState({ column_select_area_visible: !this.state.column_select_area_visible }); }}
                        class=""
                        id="tmp"
                        icon="fas fa-angle-down"
                        label="表示設定"
                        message="テーブルの表示設定を変更出来ます。"
                    />
                </Col>
            </>)
        }
        else {
            return (<></>)
        }
    }
    select_show_recode_view () {
        if ( this.state.defaultShowRecodeFlag === true ) {
            return(<>
                <Row className={this.state.column_select_area_visible ? 'on' : 'off'}>
                    <Col md="12" className="margin-auto">
                        <Card>
                            <CardBody className={"search-box"}>
                                <Row>
                                    <Col md="5">
                                        <FormGroup>
                                            <Input type="select" name="column" id="column" onChange={this.handleColumnChange} multiple={true}>
                                                {this.targettedDefaultColumn().map((data, index) => (
                                                    <option key={index} value={index}>{data.headerLabel ? data.headerLabel : data.Header}</option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <Button type="button" color="default" onClick={this.setReactTableColumn}>反映</Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </>)
        }
        else {
            return (<></>)
        }
    }

    sorted_options_btn () {
        if ( this.state.defaultShowSortedFlag === true ) {
            return (<>
                <Col md="2">
                    <ButtonWithTooltip
                        onclick={() => { this.setState({ column_sort_area_visible: !this.state.column_sort_area_visible }); }}
                        class=""
                        id="tmp"
                        icon="fas fa-angle-down"
                        label="並び順"
                        message="並び順を変更出来ます。"
                    />
                </Col>
            </>)
        }
        else {
            return (<></>)
        }
    }
    sorted_options_view () {
        if ( this.state.defaultShowSortedFlag === true ) {
            return (<>
                <Row className={this.state.column_sort_area_visible ? 'on' : 'off'}>
                    <Col md="12" className="margin-auto">
                        <Card>
                            <CardBody className={"search-box"}>
                                <Row>
                                    <Col md="5">
                                        <FormGroup>
                                            <Input type="select" name="column" id="column" onChange={this.handleChangeSortCols} multiple={false}>
                                                {this.state.sort_column.map((data,index)=>(
                                                    <option key={index} value={data.value}>{data.label}</option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                        <FormGroup>
                                            <Input type="select" name="sortby" id="sortby" onChange={this.handleChangeSortBy} multiple={false}>
                                                <option value="1">昇順</option>
                                                <option value="0">降順</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="3">
                                        <Button type="button" color="default" onClick={this.setSortBySearchData}>反映</Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </>)
        }
        else {
            return (<></>)
        }
    }
    handleChangeSortCols(e) {
        let val = e.target.value;
        this.setState({
            tmp_sort: {
                ...this.state.tmp_sort,
                col: val
            }
        })

    }
    handleChangeSortBy(e) {
        this.setState({
            tmp_sort: {
                ...this.state.tmp_sort,
                ask: e.target.value == "1"? true: false
            }
        })
    }
    setSortBySearchData () {
        if (this.props.changeBySortData) {
            this.props.changeBySortData(this.state.tmp_sort);
        }
    }


    columnSelectArea() {
        if (this.state.mode === 1)
            return (<></>);
        else
            return (
                <>
                    <Row>
                        {this.detail_search_btn()}
                        {this.select_show_recode_btn()}
                        {this.sorted_options_btn()}
                    </Row>
                    <br />
                    {this.detail_search_field_view()}
                    {this.select_show_recode_view()}
                    {this.sorted_options_view()}
                    <br />
                    {this.search_field_optional_view()}
                </>
            );
    }
    detail_search_btn(){
        // return this.props.detail_search_field
        // console.log('detail_search_field', this.props.detail_search_field)
        if(this.props.detail_search_field){
            return (<>
            <Col md="2">
                <div id="detailed-search-button">
                <ButtonWithTooltip
                    onclick={() => { this.setState({ detail_search: !this.state.detail_search }); }} 
                    class="" 
                    id="detail" 
                    icon="fas fa-angle-down" 
                    label="詳細検索" 
                    message="詳細検索を表示します。" />
                </div>
            </Col>        
            </>);
        }
    }
    detail_search_field_view(){

        if(this.state.detail_search){
            
            return (<>
                <Row className={this.state.detail_search ? 'on' : 'off'}>
                    <Col md="12" className="margin-auto">
                        <Card>
                            <CardBody className={"search-box"}>
                            <Row>
                            {this.props.detail_search_field_cols}
                            </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>   
            </>);     
        }
    }
    search_field_optional_view() {
        return (<>
            <Row>
                <Col md="12">
                    <Card>
                        <CardBody className={"search-box"}>
                            <Row>
                            {this.props.search_field_optional_cols}
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>);
    }

    pageChange( pageNum ){
        var setPageIndex = this.validPageNum(pageNum);

        if ( setPageIndex == this.state.pageIndex ) {
            return;
        }
        
        this.setState({pageIndex:setPageIndex});

        if ( this.props.pageChangeFunc != undefined ) {
            var pager = {"index":setPageIndex,"limit":this.state.perPage};
            this.props.pageChangeFunc( this, pager );
        }
    }

    syncData () {
        return this.state.data;
    }

    changePerPage (perPage) {
        if ( this.props.limitChangeFunc != undefined ) {
            this.props.limitChangeFunc( perPage );
        }
        this.setState({perPage: parseInt(perPage),pageIndex:0});
    }

    validPageNum ( pageNum ) {
        var setPageIndex = Number(pageNum) - 1;
        var pageCount = Math.ceil(this.state.count / this.state.perPage);
        if (setPageIndex < 0) {
            setPageIndex = 0;
        }
        else if (pageCount <= setPageIndex) {
            setPageIndex = pageCount - 1;
            if(setPageIndex < 0){
                setPageIndex = 0;
            }
        }
        return setPageIndex;
    }

    pagerPressEnter ( event ) {
        if ( event.key == "Enter" ) {
            this.pageChange(event.target.value);
        }
    }

	

    pagingHeader (refKey = "header") {
        var pageCount = Math.ceil(this.state.count / this.state.perPage);
        return (<>
        <div class="ReactTable">
            <div class="pagination-top">
                <div class="-pagination">
                    <div class="-previous">
                    {this.state.pageIndex==0 ? (<>
                        <button type="button" class="-btn" disabled="disabled" onClick={this.beforeView}>前へ</button>
                    </>):(<>
                        <button type="button" class="-btn" onClick={this.beforeView}>前へ</button>
                    </>)}
                    </div>
                    <div class="-center">
                        <span class="-pageInfo"> 
                            <div class="-pageJump">
                                {refKey == "header"?(<>
                                    <input aria-label="jump to page" type="number" ref={this.pageHeaderRef} defaultValue={this.state.pageIndex + 1} onBlur={(e)=>{this.pageChange(e.target.value)}} onKeyPress={(e)=>{this.pagerPressEnter(e)}} />
                                </>):(<>
                                    <input aria-label="jump to page" type="number" ref={this.pageFooterRef} defaultValue={this.state.pageIndex + 1} onBlur={(e)=>{this.pageChange(e.target.value)}} onKeyPress={(e)=>{this.pagerPressEnter(e)}} />
                                </>)}
                            </div> / <span>{pageCount} （計{this.state.count}件）</span>
                        </span>
                        <span class="select-wrap -pageSizeOptions">
                            {refKey == "header"?(<>
                            <select aria-label="rows per page" ref={this.pageLimitHeaderRef} onChange={(e)=>{this.changePerPage(e.target.value)}}>
                                {this.state.perPage_options.map((i) => {
                                    return (<>
                                    {this.state.perPage == i?(<><option value={i} selected>{i} 件表示</option></>):(<><option value={i}>{i} 件表示</option></>)}
                                    </>);
                                })}
                            </select>
                            </>):(<>
                            <select aria-label="rows per page" ref={this.pageLimitFooterRef} onChange={(e)=>{this.changePerPage(e.target.value)}}>
                                {this.state.perPage_options.map((i) => {
                                    return (<>
                                    {this.state.perPage == i?(<><option value={i} selected>{i} 件表示</option></>):(<><option value={i}>{i} 件表示</option></>)}
                                    </>);
                                })}
                            </select>
                            </>)}
                        </span>
                    </div>
                    <div class="-next">
                    {pageCount == 0 || (this.state.pageIndex + 1)==pageCount ? (<>
                        <button type="button" class="-btn" disabled="disabled" onClick={this.nextView}>次へ</button>
                    </>):(<>
                        <button type="button" class="-btn" onClick={this.nextView}>次へ</button>
                    </>)}
                    </div>
                </div>
            </div>
        </div>
        </>);
    }

	detailCells (row) {
//		console.log("detailCells", row)
		if ( this.props.detailCells ) {
			return this.props.detailCells(row);
		}

	}

    nextView () {
        var p = this.state.pageIndex + 1;

        if ( this.props.pageChangeFunc != undefined ) {
            var pager = {"index":p,"limit":this.state.perPage};
            this.props.pageChangeFunc( this, pager );
        }
        this.setState({pageIndex:p});

    }
    beforeView () {
        var p = this.state.pageIndex - 1;
        if ( this.props.pageChangeFunc != undefined ) {
            var pager = {"index":p,"limit":this.state.perPage};
            this.props.pageChangeFunc( this, pager );
        }
        this.setState({pageIndex:p});
    }

	clickRowCallback(row) {
        // console.log(row);
		(this.props.clickRowCallback) && this.props.clickRowCallback(this.state.data[row.index]);
		let { index, isExpanded } = row

		this.setState({
			expanded: {
				...this.state.expanded,
				[index]: isExpanded == true?  false: true
			}
		});		
    }
    callbackChangeExpanded (row) {
        this.setState({
            expanded:{
                ...this.state.expanded,
                [row.id]:this.state.expanded[row.id]? !this.state.expanded[row.id]: true
            }
        })
    }
    render() {

        let data = (this.state.with_all_check?this.state.data.map((element, index) => {
            var check;
            var item = element[this.state.unique_key];

            if ( this.state.checkedItems.length > 0) {
                var base_id, checked_id;
                switch ( this.state.unique_key ) {
                    case "INVOICE__estimate_natural_id":{
                        base_id = item.props["children"];
                        checked_id = this.state.checkedItems.find(item=>item[this.state.unique_key].props["children"] == base_id);
                    }break;
                    case "estimate_natural_id_ssv":
                    case "SECURITY_DEPOSIT__estimate_natural_id":{
                        base_id = item;
                        checked_id = this.state.checkedItems.find(item=>item[this.state.unique_key] == base_id);
                    }break;
                }
               
                check = <input type="checkbox" name="item_check" checked={element.checked === true || checked_id != undefined} onChange={(e) => { this.updateChecked(e, index) }} />
            }
            else {
                check = <input type="checkbox" name="item_check" checked={element.checked === true} onChange={(e) => { this.updateChecked(e, index) }} />
            }
            return {
                ...element,
                check
            }
        }):this.state.data)
        
        let columnSelectArea = this.columnSelectArea();

        return (
            <>
                <CardBody>
                    {columnSelectArea}
                    {this.props.checkbox_field_cols}
                    <br/>
                    <span ref={this.currentRef}></span>
                    {this.pagingHeader()}
                    <BasicTableDetails
                        columns={this.state.column}
                        data={data}
						initExpanded={this.state.expanded}
						renderRowSubComponent={({row})=>this.detailCells(row)}
                        onClickRow={(row) => {
                            this.callbackChangeExpanded(row)
                        }}
                    />
                    {this.pagingHeader("footer")}
                </CardBody>
            </>
        );
    }
}
OriginalTableDetails.propTypes = propTypes;